import { useParams } from 'react-router-dom';
import { all } from '../data/all';

function GenericSecondLevel() {
    const { country, first, second } = useParams();

    let countryData = [];
    
    all.forEach(thisCountry => {
        if (thisCountry.name.common === country) {
            countryData = JSON.stringify(thisCountry[first][second]);
        }
    })    

    return(
        <code>
            { countryData }
        </code>
    )
}

export default GenericSecondLevel;